import { render, staticRenderFns } from "./channelDetailIntro.vue?vue&type=template&id=94052aa4&scoped=true&"
import script from "./channelDetailIntro.vue?vue&type=script&lang=ts&"
export * from "./channelDetailIntro.vue?vue&type=script&lang=ts&"
import style0 from "./channelDetailIntro.vue?vue&type=style&index=0&id=94052aa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94052aa4",
  null
  
)

export default component.exports